(function () {
    'use strict';

    /*
     * A module for handling client metrics.
     */

    angular.module('GorillaBoy.ClientMetrics')
        // Register all constants handled by this module

    /* Latency metric operations
        * Each operation object contains general information about the metric and what validations it requires.
        * This info should be used to compare with and validate the fields stored in the individual metricEvents.
        * expectSameUrl indicates whether the URL should stay the same when a metricEvent is started and submitted.
        * It is possible to add custom validation fields to metric operations,
        * but new validation code will also need to be added to support it.
        */
    .constant('MetricEvents', {

        // Session Metrics
        ACTIONS: {
            CLICK: 'CLICK',
            KEYSTROKE: 'KEYSTROKE',
            OPEN: 'OPEN',
            CLOSE: 'CLOSE',
            SAVE: 'SAVE',
            CANCEL: 'SAVE',
            PASTE: 'PASTE',
            SUBMIT: 'SUBMIT',
            EDIT: 'EDIT',
            PUBLISH: 'PUBLISH'
        },

        FEEDBACK: 'FEEDBACK_',
        REGION_SELECTION: 'FEEDBACK_REGION_SELECTION',
        TEXT_SELECTION: 'FEEDBACK_TEXT_SELECTION',
        OVERALL_COMMENT: 'FEEDBACK_OVERALL_COMMENT',

        SEND_MESSAGE: 'SEND_MESSAGE_',
        FILE_BROWSER: 'FILE_BROWSER_',
        DOCUMENT_VIEW: 'DOCUMENT_VIEW_',

        TOKEN_SERVICE: {
            TOKEN_REFRESH_PROPAGATION: 'TOKEN_REFRESH_PROPAGATION'
        },

        O365: {
            ACTION_URL_FETCH_LATENCY: {
                name: 'ACTION_URL_FETCH_LATENCY'
            },
            ACCESS_TOKEN_FETCH_LATENCY: {
                name: 'ACCESS_TOKEN_FETCH_LATENCY'
            },
            O365_POST_TO_IFRAME_LATENCY: {
                name: 'O365_POST_TO_IFRAME_LATENCY'
            },
            ACCESS_TOKEN_FETCH_FAILED: {
                name: 'ACCESS_TOKEN_FETCH_FAILED'
            },
            ACTIION_URL_FETCH_FAILED: {
                name: 'ACTIION_URL_FETCH_FAILED'
            },
            OFFICE_FRAME_LOAD_COMPLETE: {
                name: "OFFICE_FRAME_LOAD_COMPLETE"
            },
            OFFICE_FRAME_CLOSED: {
                name: "OFFICE_FRAME_CLOSED"
            },
            OFFICE_FEATURE_ENABLED: {
                name: "OFFICE_FEATURE_ENABLED"
            },
            OFFICE_FEATURE_DISABLED: {
                name: "OFFICE_FEATURE_DISABLED"
            },
            OFFICE_FILE_OPENED_DOC_VIEW: {
                name: "OFFICE_FILE_OPENED_BROWSER_VIEW"
            },
            OFFICE_FILE_OPENED_BROWSER_VIEW: {
                name: "OFFICE_FILE_OPENED_DOC_VIEW"
            },
            OFFICE_PAGE_INITIALIZATION_FAILED: {
                name: "OFFICE_PAGE_INITIALIZATION_FAILED"
            },
            OFFICE_FILE_CLOSED: {
                name: "OFFICE_FILE_CLOSED"
            }
        },

        // PMET Metrics
        // Operation tracking time to load app
        APP_LOAD_EVENT: {
            name: 'APP_LOAD_EVENT'
        },
        REFRESH_TOKEN_EVENT: {
            name: 'REFRESH_TOKEN_EVENT'
        },
        RESOURCE_LOAD_EVENT: {
            name: 'RESOURCE_LOAD_EVENT'
        },
        APP_LOAD_SERVICE_COMPLETE_EVENT: {
            name: 'APP_LOAD_SERVICE_COMPLETE_EVENT'
        },
        PAGE_LOAD_EVENT: {
            name: 'PAGE_LOAD_EVENT'
        },
        PAGE_VISIBLE_EVENT: {
            name: 'PAGE_VISIBLE_EVENT'
        },
        FEEDBACK_PANEL_EVENTS: {
            API_LATENCY_FOR_FETCHING_ALL_VERSION_FEEDBACK: 'API_LATENCY_FOR_FETCHING_ALL_VERSION_FEEDBACK',
            RENDERING_LATENCY_ALL_VERSION_FEEDBACK: 'RENDERING_LATENCY_ALL_VERSION_FEEDBACK',
            //This latency is for rendering feedback input box
            RENDER_FEEDBACK_INPUT: 'DOCUMENT_VIEW_RENDER_FEEDBACK_INPUT',

            //This latency is for rendering arrow to the already rendered feedback input
            RENDER_FEEDBACK_ARROW_FOR_INPUT: 'DOCUMENT_VIEW_RENDER_FEEDBACK_ARROW_FOR_INPUT',

            //This latency is for rendering arrow to an existing feedback when user clisk on it
            RENDER_FEEDBACK_ARROW: 'DOCUMENT_VIEW_RENDER_FEEDBACK_ARROW'
        },
        DOCUMENT_VIEW_EVENT: {
            name: 'DOCUMENT_VIEW_EVENT',
            expectedSameUrl: true,
            startRoutePath: null,
            endRoutePath: null
        },
        PDF_DATA_LOADED_EVENT: {
            name: 'PDF_DATA_LOADED_EVENT'
        },
        THUMBNAIL_VIEW: {
            name: 'THUMBNAIL_VIEW_LOADED'
        },
        LIST_VIEW: {
            name: 'LIST_VIEW_LOADED'
        },
        THUMBNAIL_VIEW_DROPPED: {
            name: 'THUMBNAIL_VIEW_DROPPED'
        },
        OWNED: {
            name: 'MY_DOCUMENTS_LOAD_EVENT'
        },
        SHARED: {
            name: 'SHARED_WITH_ME_LOAD_EVENT'
        },
        FOLDER: {
            name: 'SUBFOLDER_LOAD_EVENT'
        },
        AWAITING_FEEDBACK: {
            name: 'AWAITING_MY_FEEDBACK_LOAD_EVENT'
        },
        OUT_FOR_REVIEW: {
            name: 'OUT_FOR_REVIEW_LOAD_EVENT'
        },
        RECYCLE: {
            name: 'RECYCLE_BIN_LOAD_EVENT'
        },
        FETCH_MORE_RESOURCES_EVENT: {
            name: 'FETCH_MORE_RESOURCES_EVENT'
        },
        NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES: {
            name: 'NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES'
        },
        NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES: {
            name: 'NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES'
        },
        NEW_FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES: {
            name: 'NEW_FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES'
        },
        NEW_FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES: {
            name: 'NEW_FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES'
        },
        DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES: {
            name: 'DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES'
        },
        DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES: {
            name: 'DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES'
        },
        FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES: {
            name: 'FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES'
        },
        FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES: {
            name: 'FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES'
        },
        DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES: {
            name: 'DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES'
        },
        DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES: {
            name: 'DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES'
        },
        FOLDER_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES: {
            name: 'FOLDER_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES'
        },
        FOLDER_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES: {
            name: 'FOLDER_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES'
        },
        FEEDBACK_LOADED_TIME: {
            name: 'FEEDBACK_LOADED_TIME'
        },
        FEEDBACK_LOADED_COUNTER: {
            name: 'FEEDBACK_LOADED_COUNTER'
        },
        SHARE_MODAL_COUNTER: {
            name: 'SHARE_MODAL_COUNTER'
        },
        DRAFT_ANNOTATION_COUNTER: {
            name: 'DRAFT_ANNOTATION_COUNTER'
        },
        PUBLISH_COMMENT_COUNTER: {
            name: 'PUBLISH_COMMENT_COUNTER'
        },
        FORCE_REFRESH_TOKEN_COUNTER: {
            name: 'FORCE_REFRESH_TOKEN_COUNTER'
        },
        PDF_DATA_LOADED_COUNTER: {
            name: 'PDF_DATA_LOADED_COUNTER'
        },
        USER_SIGNED_UP_PREVIEW: {
            name: 'USER_SIGNED_UP_PREVIEW'
        },
        USER_SIGNED_UP_TO_NOVA: {
            name: 'USER_SIGNED_UP_TO_NOVA'
        },
        USER_SWITCHED_BACK_TO_PROD: {
            name: 'USER_SWITCHED_BACK_TO_PROD'
        },
        NETWORK_LATENCY_EVENT: {
            name: 'NETWORK_LATENCY_EVENT'
        },
        OWNED_API_CALL_LATENCY: {
            name: 'MY_DOCUMENTS_API_CALL_LATENCY'
        },
        SHARED_API_CALL_LATENCY: {
            name: 'SHARED_WITH_ME_API_CALL_LATENCY'
        },
        AWAITING_FEEDBACK_API_CALL_LATENCY: {
            name: 'AWAITING_MY_FEEDBACK_API_CALL_LATENCY'
        },
        OUT_FOR_REVIEW_API_CALL_LATENCY: {
            name: 'OUT_FOR_REVIEW_API_CALL_LATENCY'
        },
        RECYCLE_API_CALL_LATENCY: {
            name: 'RECYCLE_BIN_API_CALL_LATENCY'
        },
        OWNED_RENDER_COMPLETE_LATENCY: {
            name: 'MY_DOCUMENTS_RENDER_COMPLETE_LATENCY'
        },
        OWNED_FIRST_PAGE_RENDER_COMPLETE_LATENCY: {
            name: 'OWNED_FIRST_PAGE_RENDER_COMPLETE_LATENCY'
        },
        SHARED_RENDER_COMPLETE_LATENCY: {
            name: 'SHARED_WITH_ME_RENDER_COMPLETE_LATENCY'
        },
        SHARED_FIRST_PAGE_RENDER_COMPLETE_LATENCY: {
            name: 'SHARED_WITH_ME_FIRST_PAGE_RENDER_COMPLETE_LATENCY'
        },
        AWAITING_FEEDBACK_RENDER_COMPLETE_LATENCY: {
            name: 'AWAITING_MY_FEEDBACK_RENDER_COMPLETE_LATENCY'
        },
        AWAITING_FEEDBACK_FIRST_PAGE_RENDER_COMPLETE_LATENCY: {
            name: 'AWAITING_FEEDBACK_FIRST_PAGE_RENDER_COMPLETE_LATENCY'
        },
        OUT_FOR_REVIEW_RENDER_COMPLETE_LATENCY: {
            name: 'OUT_FOR_REVIEW_RENDER_COMPLETE_LATENCY'
        },
        OUT_FOR_REVIEW_FIRST_PAGE_RENDER_COMPLETE_LATENCY: {
            name: 'OUT_FOR_REVIEW_FIRST_PAGE_RENDER_COMPLETE_LATENCY'
        },
        RECYCLE_RENDER_COMPLETE_LATENCY: {
            name: 'RECYCLE_BIN_RENDER_COMPLETE_LATENCY'
        },
        RECYCLE_FIRST_PAGE_RENDER_COMPLETE_LATENCY: {
            name: 'RECYCLE_FIRST_PAGE_RENDER_COMPLETE_LATENCY'
        },
        LOGIN_PAGE_RENDER_START: {
            name: "LOGIN_PAGE_RENDER_START"
        },
        LOGIN_PAGE_RENDER_REDIRECTION: {
            name: "LOGIN_PAGE_RENDER_REDIRECTION"
        },
        LOGIN_PAGE_RENDER_COMPLETE: {
            name: "LOGIN_PAGE_RENDER_COMPLETE"
        },
        USER_CLICKED_ON_FEEDBACK: {
            name: "USER_CLICKED_ON_FEEDBACK"
        },
        USER_CLICKED_ON_FEEDBACK_COMPLETE: {
            name: "USER_CLICKED_ON_FEEDBACK_COMPLETE"
        },
        DOCUMENT_VERSION_DOWNLOAD_COMPLETE: {
            name: "DOCUMENT_VERSION_DOWNLOAD_COMPLETE"
        },
        DOCUMENT_VERSION_RENDER_COMPLETE: {
            name: "DOCUMENT_VERSION_RENDER_COMPLETE"
        },
        DOCUMENT_REQUEST_START: {
            name: "DOCUMENT_REQUEST_START"
        },
        DOCUMENT_PAGE_SCROLL_LATENCY: {
            name: "DOCUMENT_PAGE_SCROLL_LATENCY"
        },
        DOCUMENT_FEEDBACK_RENDER_LATENCY: {
            name: "DOCUMENT_FEEDBACK_RENDER_LATENCY"
        },
        PDF_VIEW_PAGE_CHANGE_LATENCY: {
            name: "PDF_VIEW_PAGE_CHANGE_LATENCY"
        },
        PUBLISH_COMMENTS_WITHOUT_NOTIFICATIONS: {
            name: "PUBLISH_COMMENTS_WITHOUT_NOTIFICATIONS"
        },
        PUBLISH_COMMENTS_WITH_NOTIFICATIONS: {
            name: "PUBLISH_COMMENTS_WITH_NOTIFICATIONS"
        }
    })
    .factory('StageConfig', function () {
        var usEast1PoolId = "us-east-1:d5e068e9-787a-453e-ae41-b7e8bcaf677b";
        var apNortheast1PoolId = "ap-northeast-1:b14c3f90-dc34-4035-9068-d8dbc225224f";
        var result = {
            DEV: {
                'us-east-1': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                }
            },
            ALPHA: {
                'us-east-1': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                }
            },
            BETA: {
                'us-east-1': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                }
            },
            GAMMA: {
                'us-east-1': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                }
            },
            PROD: {
                'ap-southeast-2': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                },
                'ap-northeast-1': {
                    cognitoPoolId: apNortheast1PoolId,
                    cognitoRegion: 'ap-northeast-1'
                },
                'eu-west-1': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                },
                'us-west-2': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                },
                'us-east-1': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                },
                'ap-southeast-1': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                },
                'us-west-2-prod-beta': {
                    cognitoPoolId: usEast1PoolId,
                    cognitoRegion: 'us-east-1'
                }
            },
            DEFAULT: {
                cognitoPoolId: usEast1PoolId,
                cognitoRegion: 'us-east-1'
            }
        };

        for (var i = 1; i <= 10; i++) {
            result.PROD['us-west-2-prod-flight' + i] = {
                cognitoPoolId: usEast1PoolId,
                cognitoRegion: 'us-east-1'
            };
        }
        return result;
    });
}());
